export default "__VITE_ASSET__DbAT5EL0__"